module.exports = __webpack_public_path__ + "assets/img/honor1.ea92cb44.jpg";